<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="#/contact"> Contact us </a>
          </li>
          <!--!<li>
            <a href="#/about"> About Us </a>
          </li>-->
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, made with <md-icon>favorite</md-icon> by GVC Inc
      </div>
    </div>
    <cookie-law theme="blood-orange" >
    </cookie-law>
  </footer>
</template>
<script>
import CookieLaw from "vue-cookie-law";
export default {
  components: { CookieLaw },
  props: {
    backgroundColor: String,
    type: String,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
